import React from 'react';
import { Panel } from './panels/PanelHeader.js';
import { Avatar, StatusBadge, type EmployeeView } from '../shared';

interface IdentityRailProps {
  employee: EmployeeView;
  projectName: string;
  linkedToProject: boolean;
}

export const IdentityRail: React.FC<IdentityRailProps> = ({ employee, projectName, linkedToProject }) => (
  <Panel>
    <div className="flex items-start gap-3 border-b border-border p-4">
      <Avatar label={employee.name} kind={employee.kind} initials={employee.initials} size={48} showKind />
      <div className="min-w-0">
        <div className="truncate text-sm font-semibold text-heading">{employee.name}</div>
        <div className="truncate text-xs text-muted">{employee.role}</div>
        <div className="mt-2">
          <StatusBadge status={employee.status} label={employee.statusLabel} compact />
        </div>
      </div>
    </div>

    <dl className="divide-y divide-border text-xs">
      <Row label="Project" value={projectName} />
      <Row label="Project link" value={linkedToProject ? 'Linked' : 'Reusable'} />
      <Row label="Team" value={linkedToProject ? (employee.team ?? '—') : '—'} />
      <Row label="Manager" value={employee.manager ?? '—'} />
      <Row label="Workstream" value={linkedToProject ? (employee.workstream ?? '—') : '—'} />
      <Row label="Tier" value={employee.tier} />
      <Row label="Kind" value={employee.kind === 'ai' ? 'AI worker' : 'Human'} />
      {employee.mandate && (
        <div className="px-4 py-2.5">
          <dt className="font-mono text-[10px] uppercase tracking-wider text-faint">Mandate</dt>
          <dd className="mt-1 text-xs text-body leading-snug">{employee.mandate}</dd>
        </div>
      )}
    </dl>
  </Panel>
);

const Row: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div className="flex items-baseline justify-between gap-3 px-4 py-2">
    <dt className="font-mono text-[10px] uppercase tracking-wider text-faint">{label}</dt>
    <dd className="truncate text-xs text-body">{value}</dd>
  </div>
);
